import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import lnfEn from './en-US/lnf.json';
import lnfEs from './es-US/lnf.json';
import commonEn from './en-US/common.json';
import commonEs from './es-US/common.json';
import worksheetMakerEn from './en-US/worksheet-maker.json';
import worksheetMakerEs from './es-US/worksheet-maker.json';
import a11yEn from './en-US/a11y.json';
import a11yEs from './es-US/a11y.json';

export const localeToLanguage = {
  EN_US: 'English',
  ES_US: 'Español',
};

const DEFAULT_LOCALE = 'EN_US';

const initializeI18n = () => {
  i18n.use(initReactI18next).init({
    lng: DEFAULT_LOCALE,
    resources: {
      [DEFAULT_LOCALE]: {
        translation: {
          lnf: lnfEn,
          common: commonEn,
          worksheet: worksheetMakerEn,
          a11y: a11yEn,
        },
      },
      ES_US: {
        translation: {
          lnf: lnfEs,
          common: commonEs,
          worksheet: worksheetMakerEs,
          a11y: a11yEs,
        },
      },
    },
    fallbackLng: DEFAULT_LOCALE,
    nsSeparator: false,
    // keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });
};

export const translate = (namespace, key, options = {}) => {
  const trans = i18n.t(`${namespace}.${key}`, options);

  return trans;
};

export const setLocale = (locale = DEFAULT_LOCALE) => {
  i18n.changeLanguage(locale);
};

export const getLocale = () => {
  try {
    const locale = i18n.language;

    return locale || DEFAULT_LOCALE;
  } catch (err) {
    return DEFAULT_LOCALE;
  }
};

export default initializeI18n;
